import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import iziToast from "izitoast";
import "izitoast/dist/css/iziToast.min.css";

const dateTimePicker = document.querySelector("#datetime-picker");
const startButton = document.querySelector("[data-start]");

const daysValue = document.querySelector("[data-days]");
const hoursValue = document.querySelector("[data-hours]");
const minutesValue = document.querySelector("[data-minutes]");
const secondsValue = document.querySelector("[data-seconds]");

startButton.addEventListener("click", onStartButtonClick);

startButton.disabled = true;

let selectedDate = null;
let timerId = null;

flatpickr(dateTimePicker, {
    enableTime: true,
    time_24hr: true,
    defaultDate: new Date(),
    minuteIncrement: 1,
    onClose(selectedDates) {
        const currentDate = new Date();
        selectedDate = selectedDates[0].getTime();

        if (selectedDate <= currentDate) {
            iziToast.error({
                title: 'Error',
                message: 'Please choose a date in the future',
                position: 'topRight',
            });
            startButton.disabled = true;
        } else {
            startButton.disabled = false;
        }
    },
});

function onStartButtonClick() {
    startButton.disabled = true;
    dateTimePicker.disabled = true;

    timerId = setInterval(() => {
        const currentTime = Date.now();
        const timeDifference = selectedDate - currentTime;

        if (timeDifference <= 0) {
            clearInterval(timerId);
            updateTimerInterface(0, 0, 0, 0);
            dateTimePicker.disabled = false;
            return;
        }

        const time = convertMs(timeDifference);
        updateTimerInterface(time.days, time.hours, time.minutes, time.seconds);
    }, 1000);
}

function updateTimerInterface(d, h, m, s) {
    daysValue.textContent = addLeadingZero(d);
    hoursValue.textContent = addLeadingZero(h);
    minutesValue.textContent = addLeadingZero(m);
    secondsValue.textContent = addLeadingZero(s);
}

function addLeadingZero(value) {
    return String(value).padStart(2, "0");
}

function convertMs(ms) {
    const second = 1000;
    const minute = second * 60;
    const hour = minute * 60;
    const day = hour * 24;

    const days = Math.floor(ms / day);
    const hours = Math.floor((ms % day) / hour);
    const minutes = Math.floor(((ms % day) % hour) / minute);
    const seconds = Math.floor((((ms % day) % hour) % minute) / second);

    return { days, hours, minutes, seconds };
}